var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"nobody":""}},[_c('JobMetrics',{staticClass:"job-metrics",attrs:{"job-id":_vm.args.job_id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }